import React from "react"
import {INTEGRATION_KEY, INTEGRATION_LABEL_OLD} from "../../state/integration/Constants"
import useModal from "../../common/hooks/UseModal"
import ConnectIntegrationButton from "../../common/button/connectintegrationbutton.component"
import {Intl} from "../../state/helpers/IntlProps"
import Integrations from "../../integration/Integrations"
import {injectIntl, defineMessages} from "react-intl"

namespace SignUpOptionType {
    export const Single = "default"
    export const Lightspeed = "lightspeed"
}
type SignUpOptionType = typeof SignUpOptionType[keyof typeof SignUpOptionType];

const DefaultSignUpOptions: INTEGRATION_KEY[] = [
    // INTEGRATION_KEY.SQUARE,
    INTEGRATION_KEY.QUICK_BOOKS,
    INTEGRATION_KEY.SHOPIFY
]

export const LightspeedSignUpOptions: INTEGRATION_KEY[] = [
    INTEGRATION_KEY.LIGHTSPEED_RETAIL,
    INTEGRATION_KEY.VEND,
]

export const IntegrationSignUpOptions: { [key in SignUpOptionType]: INTEGRATION_KEY[] } = {
    [SignUpOptionType.Lightspeed]: LightspeedSignUpOptions,
    [SignUpOptionType.Single]: DefaultSignUpOptions,
}

const messages = defineMessages({
    [SignUpOptionType.Lightspeed]: {
        id: "auth.components.IntegrationSignUpButtons.lightspeed",
        defaultMessage: "Select Your Series",
    }
})

type Props = {
    intl: Intl,
    referrer: string,
    utmMedium: string,
    utmCampaign: string,
    utmSource: string,
}

const IntegrationSignUpButtons = (props: Props) => {
    const {modal, setContent, toggleShow} = useModal({
        showFooter: false,
        centered: true,
    })

    const getOptions = (
        integrationKeys: INTEGRATION_KEY[],
        onClickOverride: (() => void) | null,
    ): JSX.Element[] => {
        return integrationKeys.map((integrationKey: INTEGRATION_KEY, i) => {
            return (
                <div key={i} className="row justify-content-center mb-3 mt-3">
                    <div className="col-md-12 col-12 justify-content-center d-flex">
                        <ConnectIntegrationButton
                            integrationKey={integrationKey}
                            signUp={true}
                            key={integrationKey}
                            iconBtnColor={"btn-dark"}
                            actionBtnColor={"btn-dark"}
                            referrer={props.referrer}
                            utmMedium={props.utmMedium}
                            utmCampaign={props.utmCampaign}
                            utmSource={props.utmSource}
                            url={Integrations.getIntegrationSignUpRedirectUrl(integrationKey)}
                            buttonLabel={buttonLabels(integrationKey)}
                            onClickOverride={onClickOverride}
                        />
                    </div>
                </div>
            )
        })
    }

    const content = Object.keys(IntegrationSignUpOptions).map((key: string) => {
        switch (key) {
        case SignUpOptionType.Single:
            return getOptions(IntegrationSignUpOptions[key], null)

        case SignUpOptionType.Lightspeed:
            return getOptions(
                [key],
                () => {
                    setContent({
                        header: props.intl.formatMessage(messages[key]),
                        body: getOptions(IntegrationSignUpOptions[key], null),
                    })
                    toggleShow()
                })
        }
    })

    return (
        <>
            {modal}
            {content}
        </>
    )
}

const buttonLabels = (key: INTEGRATION_KEY) => {
    switch (key) {
    case INTEGRATION_KEY.LIGHTSPEED_RETAIL:
    case INTEGRATION_KEY.VEND:
        return `${Integrations.getIntegrationNameFromKey(key)} (${INTEGRATION_LABEL_OLD[key]})`
    default:
        return null
    }
}

export default injectIntl(IntegrationSignUpButtons)


// WEBPACK FOOTER //
// ./src/auth/components/IntegrationSignUpButtons.tsx